import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ClientVehiclePicker, PICKER_TITLES } from "@/components/ClientVehiclePicker";
import { api, errorMessage } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";

export function NewQuoteDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  const { data: settings } = useFetch(() => api.get("/settings"), [], { enabled: open });
  const [clientId, setClientId] = useState("");
  const [vehicleId, setVehicleId] = useState("none");
  const [mode, setMode] = useState("pick");
  const [busy, setBusy] = useState(false);

  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/quotes", { client_id: clientId, vehicle_id: vehicleId === "none" ? null : vehicleId, lines: [], validity_days: settings?.quote_validity_days ?? 30 });
      toast.success(`Devis ${data.number} créé — ajoutez les lignes puis imprimez ou envoyez-le`);
      onOpenChange(false);
      navigate(`/devis/detail/${data.id}`);
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" aria-describedby={undefined} data-testid="new-quote-dialog">
        <DialogHeader><DialogTitle>{PICKER_TITLES[mode] || "Nouveau devis"}</DialogTitle></DialogHeader>
        <ClientVehiclePicker prefix="new-quote" enabled={open} clientId={clientId} vehicleId={vehicleId} onClientChange={setClientId} onVehicleChange={setVehicleId} mode={mode} setMode={setMode} />
        {mode === "pick" && <DialogFooter className="gap-2"><Button variant="outline" onClick={() => onOpenChange(false)} data-testid="new-quote-cancel">Annuler</Button><Button onClick={create} disabled={!clientId || busy} data-testid="new-quote-create">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Créer le devis"}</Button></DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
